import { chat as baseChat, type HistoryTurn } from "../../../scene-harness/src/lib/chat";

export type { HistoryTurn };

export type IntakeTrigger = "intake_submit" | "intake_body_start" | "intake_wake";

export interface IntakeChatResult {
  text: string;
  error?: boolean;
}

export async function callIntake(
  trigger: IntakeTrigger,
  utterance: string | null,
  history: HistoryTurn[],
  gameState: Record<string, unknown> = {},
): Promise<IntakeChatResult> {
  const res = await baseChat({
    character: "intake" as never,
    trigger: trigger as never,
    pilot_utterance: utterance,
    game_state: gameState,
    history,
  });
  return { text: res.text, error: res.error };
}
